import ErrorIcon from "@/assets/common/ic_error.svg";
import DeniedIcon from "@/assets/common/ic_denied.svg";
import FileDetele from "@/assets/record/ic_file_delete.svg";
import IC_RETRY from "@/assets/record/ic_retry.svg?react";
import EasyLoading from "@/component/EasyLoading";
import { shareType } from "@/sections/Share/useShare";
import { CompanyInfo } from "@/types/company";
import userInfoStore, { getUser } from "@/store/user.store";
import Button from "@/component/Button";
import CompanyHelper from "@/bussiness/CompanyHelper";
import { IdentityType } from "@/constants/user";
import IC_PERSONAL from "@/assets/common/ic_personal.svg?react";
import "./index.css";
interface ErrorPageProps {
  loading: boolean;
  viewableOrg: CompanyInfo | null;
  shareType?: shareType;
  checkNeedPassword: () => void;
}

const ErrorPage = (props: ErrorPageProps) => {
  const { loading, viewableOrg, shareType, checkNeedPassword } = props;
  const company = userInfoStore((state) => state.company);

  const getErrorImg = () => {
    if (shareType === "isDelete") {
      return FileDetele;
    }
    if (shareType === "orgDenied") {
      return DeniedIcon;
    }
    return ErrorIcon;
  };

  const getError = () => {
    if (shareType === "isDelete") {
      return "源文件已删除";
    }
    if (shareType === "noExist") {
      return "当前链接已失效";
    }
    if (shareType === "expired") {
      return "当前链接已失效";
    }
    if (shareType === "orgDenied") {
      getUser();
      return "没有权限访问";
    }
  };

  const handleSwitchOrg = () => {
    if (!viewableOrg?.identityId) return;
    CompanyHelper.switchCompany(viewableOrg.identityId);
  };

  const currentCompanyName =
    company?.identityType === IdentityType.personal
      ? "个人账户"
      : company?.companyName;

  const isPersonal = viewableOrg?.identityType === IdentityType.personal;

  const name =
    viewableOrg?.identityType === IdentityType.personal
      ? "个人账户"
      : viewableOrg?.companyName;

  return (
    <div className="w-full h-full flex flex-col justify-center items-center bg-#F2F3F5">
      <EasyLoading isShow={loading} />
      {!loading && (
        <>
          {shareType === "initCheckError" ? (
            <>
              <IC_RETRY className="size-20 mb-4" />
              <div
                className="mt-4 b-1 border-solid b-#DBDEE4 w-22 h-8 rounded-1.5 flex justify-center items-center text-mx-secondary text-3.5 cursor-pointer"
                onClick={() => {
                  checkNeedPassword();
                }}
              >
                重试
              </div>
            </>
          ) : (
            <>
              <img src={getErrorImg()} className="size-20 mb-4" />
              <div className="text-3.5 color-#1F25334D font-400">
                {getError()}
              </div>
              {viewableOrg && (
                <div className="mt-8 w-89.5 rd-3 bg-#fff">
                  <div className="lh-13 px-4 text-3.5 b-1px b-b-solid b-#F4F6F9">
                    当前登录账号为
                    <span className="font-500">{currentCompanyName}</span>
                    ，你可以：
                  </div>
                  <div className="flex items-center justify-between px-4 h-18">
                    <div className="mr-3 w-10 h-10 b-1px b-solid b-#ECEEF3 rd-2 flex items-center justify-center">
                      {viewableOrg.logo ? (
                        <img src={viewableOrg.logo} className="size-7.5" />
                      ) : (
                        <div className="w-10 h-10 rd-2 bg-img flex justify-center items-center">
                          {isPersonal ? (
                            <IC_PERSONAL className="w-4.5 h-4.5" />
                          ) : (
                            <span className="text-size-3.5 text-white font-600">
                              {viewableOrg?.companyName.substring(0, 2)}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="w-46.5 text-#30343C h-5.5 lh-5.5 text-3.5 mx-text-ellipsis">
                        {name}
                      </div>
                      <div className="w-46.5 text-mx-tertiary h-5.5 lh-5.5 text-3 mx-text-ellipsis">
                        {viewableOrg.realname || viewableOrg.name || "-"}
                      </div>
                    </div>
                    <Button
                      type="primary"
                      onClick={handleSwitchOrg}
                      className="min-w-20.5 h-7 lh-4.25 flex items-center justify-center text-3"
                    >
                      切换并访问
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ErrorPage;
